import { render, staticRenderFns } from "./CardModal.vue?vue&type=template&id=3e3b451c&scoped=true"
import script from "./CardModal.vue?vue&type=script&lang=ts"
export * from "./CardModal.vue?vue&type=script&lang=ts"
import style0 from "./CardModal.vue?vue&type=style&index=0&id=3e3b451c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3b451c",
  null
  
)

export default component.exports